import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();

export const addFeeApi = async (
    url: string,
    amount: Number | null,
    userId: string | null,
    typeId: string,
    courseOfferingId: string
) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.post(
            `${url}/Fees/Create`, {
            amount,
            userId,
            typeId,
            courseOfferingId
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
        )
        return response.data;
    } catch (error) {
        throw error
    }
}

export const getAllFeeApi = async (url: string) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.get(
            `${url}/Fees/GetAll`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getFeeByUserIdApi = async (url: string) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.get(
            `${url}/Fees/GetByUserId`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getFeeByTypeIdApi = async (url: string, typeId: string) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.get(
            `${url}/Fees/GetByTypeId/${typeId}`, // Include typeId in the URL path
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateAmountApi = async (url: string, id: string, amount: number, regId: string) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.post(
            `${url}/Fees/UpdateAmount/${id}`, // Include id in the URL path
            { amount, regId }, // Send amount in the request body
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getFeeRenewalsApi = async (url: string) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.get(
            `${url}/Fees/FeeRenewals`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getAllFeeByUserIdApi = async (url: string, userId?: string) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.get(
            `${url}/Fees/GetAllByUserId${userId ? `?userId=${userId}` : ""}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};